import { computed, reactive, ref } from 'vue'
import * as api from '@/modules/failed-login-attempts/api'
import { FailedLoginAttempt } from '@/modules/failed-login-attempts/types'
import { SimpleListFilterParameters } from '@/views/_shared/search-list/types'

export * from './types'

const failedLoginAttempts = ref<FailedLoginAttempt[]>([])
const failedLoginAttemptsCount = ref<number>()

const defaultSortBy = 'id desc'

export const failedLoginAttemptsFilter = reactive<SimpleListFilterParameters>({
    search: '',
    sortBy: null,
    limit: 10,
    offset: 0
})

const getFailedLoginAttempts = () => {
    return api.getFailedLoginAttempts(
        failedLoginAttemptsFilter.search,
        failedLoginAttemptsFilter.sortBy || defaultSortBy,
        failedLoginAttemptsFilter.limit,
        failedLoginAttemptsFilter.offset
    ).then(
        failedLoginAttemptsList => {
            failedLoginAttempts.value = failedLoginAttemptsList.results
            failedLoginAttemptsCount.value = failedLoginAttemptsList.count
        }
    )
}

const deleteFailedLoginAttempt = (id: string) => api.deleteFailedLoginAttempt(id).then(async () => {
    await getFailedLoginAttempts()
})

export function useFailedLoginAttemptsModule () {
    return {
        failedLoginAttempts: computed(() => failedLoginAttempts.value),
        failedLoginAttemptsCount: computed(() => failedLoginAttemptsCount.value),
        getFailedLoginAttempts,
        getFailedLoginAttempt: api.getFailedLoginAttempt,
        deleteFailedLoginAttempt,
        failedLoginAttemptsFilter
    }
}
